import { doorClient, resolve, ImResponse } from '.';
import type {
  ContentParameter,
  OfficialScenarioDetailParams,
  OfficialScenarioListParams,
  OfficialScenarioLogParams,
  OfficialScenarioLogResponse,
  OfficialScenarioTodoPolicy,
  IntentGroup,
  Scenario,
  UpdateOfficialScenarioParams,
  UpdateOfficialScenarioPolicyParams,
  UpdateOfficialScenarioSubPolicyParams,
} from 'views/PureLLM/Types/api';

export function getOfficialScenarioList(params: OfficialScenarioListParams, signal?: AbortSignal) {
  return resolve(
    doorClient.post<ImResponse<IntentGroup[]>>('/oversea-llm/llm-merchant/scenario/list', params, {
      signal,
    }),
  );
}

export function getOfficialScenarioDetail(
  params: OfficialScenarioDetailParams,
  signal?: AbortSignal,
) {
  return resolve(
    doorClient.post<ImResponse<Scenario>>('/oversea-llm/llm-merchant/scenario/detail', params, {
      signal,
    }),
  );
}

export function updateOfficialScenario(params: UpdateOfficialScenarioParams) {
  return resolve(
    doorClient.post<ImResponse<unknown>>('/oversea-llm/llm-merchant/scenario', params),
  );
}

export function updateOfficialScenarioPolicy(params: UpdateOfficialScenarioPolicyParams) {
  return resolve(
    doorClient.post<ImResponse<unknown>>('/oversea-llm/llm-merchant/scenario/policy', params),
  );
}

export function updateOfficialScenarioSubPolicy(params: UpdateOfficialScenarioSubPolicyParams) {
  return resolve(
    doorClient.post<ImResponse<unknown>>(
      '/oversea-llm/llm-merchant/scenario/policy/sub-policy',
      params,
    ),
  );
}

export function getOfficialScenarioLogs(params: OfficialScenarioLogParams, signal?: AbortSignal) {
  return doorClient
    .post<OfficialScenarioLogResponse>('/oversea-llm/llm-merchant/scenario/log', params, {
      signal,
    })
    .then((response) => response.data);
}

export function getOfficialScenarioTodoPolicies(signal?: AbortSignal) {
  return resolve<{
    policies: OfficialScenarioTodoPolicy[];
  }>(
    doorClient.get('/overseaim-hi-manager/v1/todo/mergedTodoPolicy', {
      signal,
    }),
  );
}

export function getContentParameterList(params: { language: string }, signal?: AbortSignal) {
  return resolve(
    doorClient.post<ImResponse<ContentParameter[]>>(
      '/oversea-llm/llm-merchant/content-parameter/list',
      params,
      { signal },
    ),
  );
}
